import { a as push, c as attr_class, e as escape_html, l as bind_props, p as pop, m as stringify } from "./index2.js";
function Modal($$payload, $$props) {
  push();
  let { show = void 0, title, children, modalClass = "max-w-lg" } = $$props;
  if (
    // Prevent body scroll when modal is open
    // Cleanup when component is destroyed
    show
  ) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="fixed inset-0 z-50 flex items-center justify-center p-4" aria-modal="true"><div class="fixed inset-0 bg-black/50 backdrop-blur-[2px] transition-all" aria-hidden="true"></div> <div${attr_class(`relative z-50 flex max-h-[90vh] w-full flex-col overflow-hidden rounded-lg bg-white shadow-xl transition-all ${stringify(modalClass)}`)}><div class="flex shrink-0 items-center justify-between border-b border-gray-200 p-6"><h2 class="text-xl font-semibold text-gray-900">${escape_html(title)}</h2> <button class="focus:ring-primary rounded-md p-1 text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-offset-2 focus:outline-none" aria-label="Close Button"><svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg></button></div> <div class="flex-1 overflow-y-auto p-6">`);
    children?.($$payload);
    $$payload.out.push(`<!----></div></div></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]-->`);
  bind_props($$props, { show });
  pop();
}
export {
  Modal as M
};
